import React from "react";
import { capitalizeFirstLetter } from './globalFunction';

export default function CompLeaveBalance(getCompLeaveBalance, intl) {
    return getCompLeaveBalance
            .filter(item => item.comp_leave_balance && item.comp_leave_balance.length !== 0)
            .map(item => ({
                staffNo: item.staff_no,
                employeeName: item.employee_name,
                position: item.position,
                location: item.location.name,
                department: item.department.name,
                staffDuty: capitalizeFirstLetter(item.staff_duty),
                total: item?.comp_leave_balance?.total ? item.comp_leave_balance.total.toFixed(1) : '0',
                taken: item?.comp_leave_balance?.taken ? item.comp_leave_balance.taken.toFixed(1) : '0',
                balance: item?.comp_leave_balance?.balance ? item.comp_leave_balance.balance.toFixed(1) : '0',
                toBeExpiredBalance: item?.comp_leave_balance?.toBeExpiredBalance ? item.comp_leave_balance.toBeExpiredBalance.toFixed(1) : '0',
                recentExpiredBalance: item?.comp_leave_balance?.recentExpiredBalance ? item.comp_leave_balance.recentExpiredBalance.toFixed(1) : '0',
                totalCashedOutHours: item?.comp_leave_balance?.totalCashedOutHours ? item.comp_leave_balance.totalCashedOutHours.toFixed(1) : '0',
            }));
}